import { render } from "./BarcodeNotificationDialog.vue?vue&type=template&id=f6654ba0&scoped=true"
import script from "./BarcodeNotificationDialog.vue?vue&type=script&lang=ts"
export * from "./BarcodeNotificationDialog.vue?vue&type=script&lang=ts"

import "./BarcodeNotificationDialog.vue?vue&type=style&index=0&id=f6654ba0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f6654ba0"

export default script